import React from 'react';

import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';
import Tooltip from '@atlaskit/tooltip';

import { IssueTransitionFormRowData } from 'src/redux/jira/types';

import * as styles from './issue-transition-form-row.style';
import StatusLozenge from './status-lozenge';

type AutomaticIssueTransitionFormRowProps = {
  issueTransitionFormRow: IssueTransitionFormRowData;
};

/* eslint @typescript-eslint/ban-types: "warn" */
const AutomaticIssueTransitionFormRow: React.FC<
  AutomaticIssueTransitionFormRowProps
> = ({ issueTransitionFormRow }) => {
  const { automaticTransition, selectedIssue } = issueTransitionFormRow;

  if (!automaticTransition) {
    return null;
  }

  return (
    <styles.LineContainer>
      <styles.TransitionContainer>
        <Tooltip
          content={`${selectedIssue.issue.key}: ${selectedIssue.issue.summary}`}
        >
          <styles.IssueContainer>
            <img
              src={selectedIssue.issue.issueType.iconUrl}
              alt={selectedIssue.issue.issueType.name}
            />
            <styles.IssueKeyContainer>
              {selectedIssue.issue.key}
            </styles.IssueKeyContainer>
            <styles.IssueSummaryContainer>
              {selectedIssue.issue.summary}
            </styles.IssueSummaryContainer>
          </styles.IssueContainer>
        </Tooltip>
        <styles.ArrowContainer>
          <ArrowRightIcon label="→" size="small" />
        </styles.ArrowContainer>
        <StatusLozenge transition={automaticTransition} />
      </styles.TransitionContainer>
    </styles.LineContainer>
  );
};

export default AutomaticIssueTransitionFormRow;
